import { render, staticRenderFns } from "./standingOrders.vue?vue&type=template&id=027f8bff&scoped=true&"
import script from "./standingOrders.vue?vue&type=script&lang=js&"
export * from "./standingOrders.vue?vue&type=script&lang=js&"
import style0 from "./standingOrders.vue?vue&type=style&index=0&id=027f8bff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027f8bff",
  null
  
)

export default component.exports